import React from 'react';
import {withWizard} from "../wizardComponents/wizard";
import * as style from "../cerahOnline/cerahOnline.module.scss";
import {ChooseMeetingsPerWeek} from "../wizardComponents/chooseMeetingPerWeek/chooseMeetingPerWeek";
import {CourseChoice} from "../wizardComponents/courseChoice/courseChoice";
import history from "../history/history";
import {TeacherProfilePicker} from "../teacherProfile/teacherProfilePicker";
import {TrialDatePicker} from "../wizardComponents/trialDatePicker/trialDatePicker";
import {ChooseEmergencyContactMethod} from "../wizardComponents/chooseEmergencyContactMethod/chooseEmergencyContactMethod";
import analytics from "../analytics/analytics";
import {GoogleAdWords} from "../api/googleAdwords";
import {fazebukAds} from "../api/fazebuk";
import {useLocation} from "react-router";
import {Arrow} from "../controls/arrow";
import {ChooseSize} from "../wizardComponents/chooseSize/chooseSize";
import palette from "../style/palette.module.scss";
import {Language} from "../i18n/language";
import {GroupSelection} from "../wizardComponents/groupSelection/groupSelection";
import {submitClassRequest, submitContactDetailsForTest, updateClassRequest} from "../enquiry/onlineEnquirySvc";
import {prefixPhone} from "../api/classRequestApi";
import {ChooseTestTime} from "../wizardComponents/chooseTestTime/chooseTestTime";
import {ChooseLevel} from "../wizardComponents/chooseLevel/chooseLevel";
import {GridSchedulePicker} from "../wizardComponents/gridSchedulePicker/gridSchedulePicker";
import {TestCallScheduler} from "../wizardComponents/testCallScheduler/testCallScheduler";
import {Appointment} from "../wizardComponents/appointment/appointment";
import {ChooseAgeGroup} from "../wizardComponents/chooseAgeGroup/chooseAgeGroup";
import {ContactDetailsKids} from "../wizardComponents/contactDetailsKids/contactDetailsKids";
import {classRequestApi} from "../api/classRequestApi";
import * as moment from "moment";
import {useFixedWinHeight} from "../main/main";
import {userSession} from "../userSession/userSession";
import {getStartTime, getEndTime, getDayOfWeek, ScheduleConfirmation} from "../wizardComponents/scheduleSummary/scheduleSummary";
import {waPhone} from "../whatsapp/sosmedLinkClickHdlr";
import {DownloadTheApp} from "../wizardComponents/downloadTheApp/downloadTheApp";

const stateSteps = [
  "ageGroup",
  "chosenSize",
  "meetingsPerWeek",
  "confirmed",
  "pickedSchedule",
  "scheduleConfirmed",
  "pickedTeacher",
  "trialDate",
  "availableSlots",
  "emergencyContactMethod",
  "contactDetails",
  "testCallSchedule",
  "testCallConfirmed",
  //Group steps below
  "level",
  "chosenTestTime",
  "testRequested",
  "chosenGroup",
  "newGroupRequested",
  "groupScheduleRequested",
  "groupTrialDate",
  "groupAvailableSlots",
  "chosenSchedule",
  "groupContactMethod",
  "groupContactDetails",
  "groupTestCallSchedule",
  "groupTestCallConfirmed",
];
export const ageGroupEl = 'ageGroupEl';
const generalScheduleEl = 'generalScheduleEl';
const groupSizeEl = "groupSizeEl";
const scheduleEl = "scheduleEl";
const choiceEl = "choiceEl";
const scheduleSummaryEl = "scheduleSummaryEl";
const teacherSelectionEl = "teacherSelectionEl";
const trialDateEl = "trialDateEl";
const emergencyContactEl = "emergencyContactEl";
const emergencyContactMethodEl = "emergencyContactMethodEl";
const scheduleTestCallEl = "scheduleTestCallEl";
const confirmTestCallEl = "confirmTestCallEl";
const customerWhatsappConfirmationEl = "textUsWhatsappEl";

const levelEl = "levelEl";
const chooseTestTimeEl = "chooseTestTimeEl";
const deferredTestContactEl = "testContactEl";
const immediateTestContactEl = "immediateTestContactEl";
const groupSelectionEl = "groupSelectionEl";
const groupScheduleEl = "groupScheduleEl";
const groupTrialDateEl = "groupTrialDateEl";
const groupContactMethodEl = "groupContactMethodEl";
const groupContactEl = "groupContactEl";
const groupScheduleTestCallEl = "groupScheduleTestCallEl";
const groupConfirmTestCallEl = "groupConfirmTestCallEl";
const groupCustomerWhatsappConfirmationEl = "groupTextUsWhatsappEl";

let visibleEls;
let backScrollingState;

//DO NOT declare this function inside the wizard component, since that implies the function definition changes every render,
// and React understands it has to mount every single WizardStep every time the wizard is re-rendered (every time anything is clicked
// and the state changes) because the definition of the element has changed. The nested function definition changes probably
// because it has access to the parent function closure, which changes with every invocation.
//As a consequence of the above, visibleEls and backScrollingState must be outside the scope of CerahKidsWizardComponents
function WizardStep({children, el}) {
  const vh = useFixedWinHeight();
  if (visibleEls.includes(el) || (backScrollingState && backScrollingState.scrollingBackFrom === el)) {
    return (<div id={el} className={style.wholeScreenSection} style={{minHeight: vh + "px"}}>
      {children}
    </div>);
  } else {
    return null;
  }
}

function CerahKidsWizardComponents({
    visibleEls: propsVisibleEls,
    updateState,
    backScrollingState: propsBackscrollingState
}) {
  visibleEls = propsVisibleEls;
  backScrollingState = propsBackscrollingState;

  const currSt = useLocation().state || {};
  const prevSt = backScrollingState && backScrollingState.previousState || {};
  const st = {};
  [...Object.keys(currSt), ...Object.keys(prevSt)].forEach(k => st[k] = currSt[k] || prevSt[k]);

  const strings = Language.active.cerahOnline;
  return (
    <>
      <WizardStep el={ageGroupEl}>
        <Arrow className={style.arrow} size={30} color={palette.accent1Shade2}/>
        <ChooseAgeGroup onAgeGroupChosen={ageGroupChosen}/>
      </WizardStep>

      <WizardStep el={groupSizeEl}>
        <ChooseSize onGroupChosen={() => groupSizeChosen("kelompok")}
                    onPrivateChosen={() => groupSizeChosen("privat")}/>
      </WizardStep>


      <WizardStep el={choiceEl}>
        {(st.chosenSize === "privat") &&
          <ChooseMeetingsPerWeek onMeetingsPerWeekChosen={meetingsPerWeekChosen}/>
        }
        {(st.chosenSize === "kelompok") &&
          <div className={style.choiceTitle}>2 {strings.meetingsPerWeek}</div>
        }
        <CourseChoice groupSize={st.chosenSize}
                      className={(st.chosenSize !== "kelompok" && !st.meetingsPerWeek) && style.invisible}
                      meetingsPerWeek={st.chosenSize === "kelompok" ? 2 : st.meetingsPerWeek}
                      onConfirm={choiceConfirmed}/>
      </WizardStep>

      <WizardStep el={scheduleEl}>
        <div className={style.choiceTitle}>{strings.chooseSchedule}</div>
        <GridSchedulePicker onSchedulePicked={schedulePicked} maxHours={st.meetingsPerWeek}/>
      </WizardStep>

      <WizardStep el={scheduleSummaryEl}>
        <div className={style.choiceTitle}>{strings.yourSchedule}</div>
        <ScheduleConfirmation
          pickedSchedule={st.pickedSchedule || []}
          onConfirm={scheduleConfirmed}
          onReject={() => history.goBack()}
        />
      </WizardStep>

      <WizardStep el={teacherSelectionEl}>
        <div className={style.choiceTitle}>{strings.chooseTeacher}</div>
        <TeacherProfilePicker teacherIds={[
                                "601d1bdc4b2631552881e924", //Sarah
                                "5fb6aec3d7be2400479c8de7", //Garnet
                                "5f2db6c07b929670e25b26b6", //Lane
                                "5eba734492ad124eb1629446"  //Gracie
                              ]}
                              onTeacherPicked={teacherPicked}
        />
      </WizardStep>

      <WizardStep el={trialDateEl}>
        <TrialDatePicker onTrialDatePicked={trialDatePicked}
                         pickedSchedule={st.pickedSchedule}
                         pickedTeacher={st.pickedTeacher}/>
      </WizardStep>

      <WizardStep el={emergencyContactMethodEl}>
        <ChooseEmergencyContactMethod onCallback={() => emergencyContactMethodSelected("call")}
                                      onWhatsapp={() => emergencyContactMethodSelected("wa")}/>
      </WizardStep>

      <WizardStep el={emergencyContactEl}>
        <div className={style.choiceTitle}>{strings.giveUsYourDetails}</div>
        <ContactDetailsKids validatePhoneUsingWhatsApp={st.emergencyContactMethod === 'wa' && userSession.getCountry() !== "KR"}
                            onContactDetailsGiven={contactDetailsGivenPrivate}/>
      </WizardStep>

      <WizardStep el={scheduleTestCallEl}>
        <div className={style.choiceTitle}>{strings.selectTestCallSchedule}</div>
        <div className={style.choiceSubtitle}>{strings.takesJustFiveMinutes}</div>
        <div className={style.testCallDescription}>{strings.testCallDescription}</div>
        <div className={style.testCallOuterWizardContainer}>
          <TestCallScheduler trialDateIso={st.trialDate}
                            onTestCallSchedulePicked={testCallSchedulePicked}
                            availableSlotsTimestamps={st.availableSlots}/>
        </div>
      </WizardStep>

      <WizardStep el={confirmTestCallEl}>
        <div className={style.choiceTitle}>{strings.testCallChoice}</div>
        <Appointment timeIso={st.testCallSchedule} onConfirm={testCallConfirmed}/>
      </WizardStep>

      <WizardStep el={customerWhatsappConfirmationEl}>
        <DownloadTheApp onConfirm={sendCustomerConfirmationViaWhatsapp}/>
      </WizardStep>

      {/*GROUP JOURNEY//////////////////////////////////////////////*/}

      <WizardStep el={levelEl}>
        <ChooseLevel onLevelChosen={l => levelChosen(l)}/>
      </WizardStep>

      <WizardStep el={chooseTestTimeEl}>
        <ChooseTestTime onTestTimeChosen={t => testTimeChosen(t)}/>
      </WizardStep>

      <WizardStep el={generalScheduleEl}>
        <div className={style.choiceTitle}>{strings.chooseSchedule}</div>
        <GridSchedulePicker onSchedulePicked={scheduleChosenForYoungKids} maxHours={2}/>
      </WizardStep>

      <WizardStep el={deferredTestContactEl}>
        <div className={style.choiceTitle}>{strings.wellSendYouAMsg}</div>
        <ContactDetailsKids validatePhoneUsingWhatsApp={userSession.getCountry() !== "KR"}
                            onContactDetailsGiven={contactDetailsGivenTestLater}/>
      </WizardStep>

      <WizardStep el={immediateTestContactEl}>
        <div className={style.choiceTitle}>{strings.testTakes10Minutes}</div>
        <ContactDetailsKids validatePhoneUsingWhatsApp={userSession.getCountry() !== "KR"}
                            onContactDetailsGiven={contactDetailsGivenTestNow}/>
      </WizardStep>

      <WizardStep el={groupSelectionEl}>
        <div className={style.choiceTitle}>{st.level ? strings.choosePreferredGroup : strings.exploreGroups}</div>
        <GroupSelection acceptedAges={st.ageGroup} level={st.level} onGroupSelected={st.level && groupSelected}/>
      </WizardStep>

      <WizardStep el={groupScheduleEl}>
        <div className={style.choiceTitle}>{strings.chooseSchedule}</div>
        <GridSchedulePicker onSchedulePicked={groupScheduleRequested} maxHours={2}/>
      </WizardStep>

      <WizardStep el={groupTrialDateEl}>
        <TrialDatePicker onTrialDatePicked={groupTrialDatePicked}
                         timezone={st.chosenGroup && st.chosenGroup.timezone}
                         pickedSchedule={(st.chosenGroup && st.chosenGroup.schedule || st.groupScheduleRequested)}
                         pickedTeacher={(st.chosenGroup && st.chosenGroup.teacher)}/>
      </WizardStep>

      <WizardStep el={groupContactMethodEl}>
        <ChooseEmergencyContactMethod onCallback={() => groupContactMethodSelected("call")}
                                      onWhatsapp={() => groupContactMethodSelected("wa")}/>
      </WizardStep>

      <WizardStep el={groupContactEl}>
        <div className={style.choiceTitle}>{strings.giveUsYourDetails}</div>
        <ContactDetailsKids validatePhoneUsingWhatsApp={st.groupContactMethod === 'wa' && userSession.getCountry() !== "KR"}
                            studentName={st.studentName}
                            studentAge={st.studentAge}
                            name={st.name}
                            phone={st.phone}
                            email={st.email}
                            onContactDetailsGiven={contactDetailsGivenGroup}/>
      </WizardStep>

      <WizardStep el={groupScheduleTestCallEl}>
        <div className={style.choiceTitle}>{strings.selectTestCallSchedule}</div>
        <div className={style.choiceSubtitle}>{strings.takesJustFiveMinutes}</div>
        <div className={style.testCallDescription}>{strings.testCallDescription}</div>
        <div className={style.testCallOuterWizardContainer}>
          <TestCallScheduler trialDateIso={st.groupTrialDate}
                            onTestCallSchedulePicked={testCallSchedulePickedGroup}
                            availableSlotsTimestamps={st.groupAvailableSlots}/>
        </div>
      </WizardStep>

      <WizardStep el={groupConfirmTestCallEl}>
        <div className={style.choiceTitle}>{strings.testCallChoice}</div>
        <Appointment timeIso={st.groupTestCallSchedule} onConfirm={testCallConfirmedGroup}/>
      </WizardStep>

      <WizardStep el={groupCustomerWhatsappConfirmationEl}>
        <DownloadTheApp onConfirm={sendCustomerConfirmationViaWhatsapp}
                        title={strings.yourClassIsntConfirmedYet}
                        subtitle={strings.downloadTheAppToConfirm}/>
      </WizardStep>
    </>
  );


  function ageGroupChosen(ageGroup) {
    analytics.track("onlineJour.studentAge", {ageGroup});
    if (ageGroup[0] === 0) {
      updateState({chosenSize: 'privat', ageGroup});
      analytics.track("onlineJour.groupSize", {chosenSize: "privat"});
    } else {
      updateState({ageGroup});
    }
  }

  function groupSizeChosen(chosenSize) {
    updateState({chosenSize});
    analytics.track("onlineJour.groupSize", {chosenSize});
    GoogleAdWords.getInstance().trackStudentWizardStart();
    fazebukAds.trackStudentWizardStart();
  }

  function meetingsPerWeekChosen(meetingsPerWeek) {
    updateState({meetingsPerWeek});
    analytics.track("onlineJour.meetingsPerWeek", {meetingsPerWeek});
  }

  function choiceConfirmed({meetingsPerWeek, groupSize}) {
    updateState({confirmed: true});
    analytics.track("onlineJour.pricePerMonthConfirmed", {meetingsPerWeek, groupSize})
  }

  function schedulePicked(pickedSchedule) {
    updateState({pickedSchedule});
    analytics.track("onlineJour.schedulePicked", {pickedSchedule});
  }

  function scheduleConfirmed() {
    updateState({scheduleConfirmed: true});
    analytics.track("onlineJour.scheduleConfirmed");
  }

  function teacherPicked(pickedTeacher) {
    if (st.pickedTeacher !== pickedTeacher) {
      updateState({pickedTeacher});
      analytics.track("onlineJour.teacherPicked", {pickedTeacher: pickedTeacher.name});
    }
  }

  async function trialDatePicked(trialDate) {
    const trialDateIso = trialDate.toISOString();
    const availableSlots = await retrieveAvailableTestCallSlots(trialDateIso);
    updateState({trialDate: trialDateIso, availableSlots});
    analytics.track("onlineJour.trialDate", {trialDate: trialDateIso});
  }

  function emergencyContactMethodSelected(emergencyContactMethod) {
    updateState({emergencyContactMethod});
    analytics.track("onlineJour.emergencyContactMethod", {emergencyContactMethod});
  }

  async function contactDetailsGivenPrivate(contactDetails) {
    const {
      pickedSchedule,
      emergencyContactMethod,
      trialDate,
      chosenSize,
      pickedTeacher,
      ageGroup,
    } = st;
    const cr = await submitClassRequest({
      pickedSchedule,
      contactMethod: emergencyContactMethod,
      trialDate,
      chosenSize,
      pickedTeacher,
      ageGroup,
      medium: "cerahKids",
      ...contactDetails
    });
    updateState({
      contactDetails,
      classRequest: cr
    });
    analytics.track("onlineJour.contactGiven", {contactDetails});
  }

  async function retrieveAvailableTestCallSlots(trialDateIso) {
    const availableSlots = await classRequestApi.getAvailableSlotsForTestCalls(
      moment().add(2, "hour"),
      moment(trialDateIso).subtract(24, "hour")
    );
    return availableSlots;
  }

  function testCallSchedulePicked(testCallSchedule) {
    updateState({testCallSchedule: testCallSchedule.toISOString()});
  }

  async function testCallConfirmed() {
    await classRequestApi.createTestCall({
      startTime: st.testCallSchedule,
      classRequestId: st.classRequest._id,
      guessedTimezone: moment.tz.guess()
    }, st.classRequest.updateToken);
    updateState({testCallConfirmed: true});
    analytics.track("onlineJour.testCallSchedule", {testCallSchedule: st.testCallSchedule});
  }

  function sendCustomerConfirmationViaWhatsapp() {
    analytics.track("onlineJour.waLinkClicked");
    const waText = encodeURIComponent(getWhatsappText());
    window.open(`https://wa.me/${waPhone}?text=${waText}`);
  }

  function getWhatsappText() {
    const timezone = moment.tz.guess();
    const courseSchedule = st.pickedSchedule || st.groupScheduleRequested || st.chosenGroup?.schedule;
    let schedule = courseSchedule.map(entry =>
      ` *${getDayOfWeek(entry, timezone)} | ${getStartTime(entry, timezone)} - ${getEndTime(entry, timezone)} ${moment.tz(timezone).format('z')}*`
    ).join(`\n`);
    let trialDateString =  moment(st.groupTrialDate || st.trialDate).locale(Language.activeLangIsoCode).local().format("DD MMMM");
    const studentName = `${st.studentName || (st.contactDetails ? st.contactDetails.studentName : st.groupContactDetails.studentName)}`;
    const ageGroup = `${st.ageGroup[0]} - ${st.ageGroup[1]}`;
    const parentName = `${st.name || (st.contactDetails ? st.contactDetails.name : st.groupContactDetails.name)}`;
    const testCallTime = st.groupTestCallSchedule || st.testCallSchedule;

    if (Language.activeLangIsoCode === 'id') {
      const groupSizeString = st.chosenSize === "kelompok" ? "Kelompok" : "Privat";
      const courseString = st.chosenGroup ? ` Kursus: *${st.chosenGroup.name}*\n\n` : "";
      const teacherString = st.pickedTeacher ? ` Guru: *${st.pickedTeacher.name}*\n\n`: "";
      const levelString = st.testResultLevel ? ` Hasil tes: *${st.level}*\n\n` : "";
      const testCallString = testCallTime ? ` Tes koneksi: *${moment(testCallTime).locale(Language.activeLangIsoCode).local().format("DD MMMM HH:mm")}*\n\n` : "";
      return `Halo, saya ingin mengkonfirmasi permintaan kelas bahasa inggris berikutnya\n\n*` +
        `==== CerahKids ${groupSizeString} ====*\n\n` +
        `${courseString}` +
        `${teacherString}` +
        ` Nama murid: *${studentName}*\n\n` +
        ` Usia murid: *${ageGroup}*\n\n` +
        `${levelString}` +
        ` Nama orangtua: *${parentName}*\n\n` +
        ` Jadwal:\n${schedule}\n\n` +
        `${testCallString}` +
        ` Kelas percobaan: *${trialDateString}*.`;
    }

    const groupSizeString = st.chosenSize === "kelompok" ? "Group" : "Private";
    const courseString = st.chosenGroup ? ` Course: *${st.chosenGroup.name}*\n\n` : "";
    const teacherString = st.pickedTeacher ? ` Teacher: *${st.pickedTeacher.name}*\n\n`: "";
    const levelString = st.testResultLevel ? ` Test result: *${st.level}*\n\n` : "";
    const testCallString = testCallTime ? ` Tes koneksi: *${moment(testCallTime).locale(Language.activeLangIsoCode).local().format("DD MMMM HH:mm")}*\n\n` : "";
    return `Hi I'd like to confirm my request for classes with the following details:\n\n` +
      `*==== CerahKids ${groupSizeString} ====*\n\n` +
      `${courseString}` +
      `${teacherString}` +
      ` Student name: *${studentName}*\n\n` +
      ` Age group: *${ageGroup}*\n\n` +
      `${levelString}` +
      ` Parent name: *${parentName}*\n\n` +
      ` Schedule:\n${schedule}\n\n` +
      `${testCallString}` +
      ` Trial class: *${trialDateString}*.`;
  }

  function scheduleChosenForYoungKids(chosenSchedule) {
    updateState({chosenSchedule});
    analytics.track("onlineJour.schedule", {chosenSchedule});
  }

  function levelChosen(level) {
    updateState({level});
    analytics.track("onlineJour.level", {level});
  }

  function testTimeChosen(chosenTestTime) {
    updateState({chosenTestTime});
    analytics.track("onlineJour.testTime", {chosenTestTime});
  }

  async function contactDetailsGivenTestLater({studentName, email, phone, name, studentAge}) {
    const yearOfBirth = moment().get('year') - studentAge;
    const {ageGroup} = st;
    const {crId, token} = await submitContactDetailsForTest({
      studentName,
      yearOfBirth,
      name,
      email,
      phone,
      deferred: true,
      medium: "cerahKids",
      ageGroup,
    });
    updateState({name, email, phone, studentName, studentAge, openClassRequestId: crId, openClassRequestToken: token, testRequested: true});
    analytics.track("onlineJour.contactGiven", {name, email, phone, testRequested: "deferred"});
  }

  async function contactDetailsGivenTestNow({studentName, email, phone, name, studentAge}) {
    const yearOfBirth = moment().get('year') - studentAge;
    const {ageGroup} = st;
    const {crId, token} = await submitContactDetailsForTest({
      studentName,
      yearOfBirth,
      name,
      email,
      phone,
      medium: "cerahKids",
      ageGroup,
    });
    const newState = updateState({name, email, phone, studentName, studentAge, openClassRequestId: crId, openClassRequestToken: token, testRequested: true});
    analytics.track("onlineJour.contactGiven", {name, email, phone, testRequested: "inmmediate"});
    history.push(`/test/level/intro?p=${phone && prefixPhone(phone).replace("+", "")}`, {
      onResultsRedirectTo: {
        pathname: "/cerahKids",
        state: newState
      },
    });
  }

  function groupSelected(course) {
    if (course === null) {
      updateState({newGroupRequested: true, chosenGroup: null});
      analytics.track("onlineJour.newGroupRequested");
    } else {
      updateState({chosenGroup: course, newGroupRequested: null});
      analytics.track("onlineJour.groupChosen", {group: course.name});
    }
  }

  function groupScheduleRequested(groupScheduleRequested) {
    updateState({groupScheduleRequested});
    analytics.track("onlineJour.schedulePicked", {pickedSchedule: groupScheduleRequested});
  }

  async function groupTrialDatePicked(trialDate) {
    const trialDateIso = trialDate.toISOString();
    const groupAvailableSlots = await retrieveAvailableTestCallSlots(trialDateIso);
    updateState({
      groupTrialDate: trialDateIso,
      groupAvailableSlots
    });
    analytics.track("onlineJour.trialDate", {trialDate: trialDateIso});
  }

  function groupContactMethodSelected(groupContactMethod) {
    if (st.openClassRequestId) {
      let {
        groupScheduleRequested: pickedSchedule,
        chosenGroup,
        groupTrialDate: trialDate,
        chosenSize,
        level,
        name,
        chosenSchedule,
        email,
        phone
      } = st;
      let pickedTeacher = undefined;
      if (chosenGroup) {
        pickedSchedule = chosenGroup.schedule;
        pickedTeacher = chosenGroup.teacher;
      }
      if (chosenSchedule) {
        pickedSchedule = chosenSchedule;
      }
      updateClassRequest(st.openClassRequestId, st.openClassRequestToken, {
        pickedSchedule,
        contactMethod: groupContactMethod,
        trialDate,
        chosenSize,
        pickedTeacher,
        level: level || undefined,
        course: chosenGroup,
        medium: "cerahKids",
        name,
        email,
        phone,
      });
    }
    updateState({groupContactMethod});
    analytics.track("onlineJour.emergencyContactMethod", {groupContactMethod});
  }

  async function contactDetailsGivenGroup(groupContactDetails) {
    let {
      groupScheduleRequested: pickedSchedule,
      ageGroup,
      chosenGroup,
      contactMethod: groupContactMethod,
      groupTrialDate: trialDate,
      chosenSize,
      newGroupRequested,
      level,
      chosenSchedule
    } = st;
    let pickedTeacher = undefined;
    if (chosenGroup) {
      pickedSchedule = chosenGroup.schedule;
      pickedTeacher = chosenGroup.teacher;
    }
    if (chosenSchedule) {
      pickedSchedule = chosenSchedule;
    }
    const cr = await submitClassRequest({
      pickedSchedule,
      contactMethod: groupContactMethod,
      trialDate,
      chosenSize,
      pickedTeacher,
      ageGroup,
      level: level || undefined,
      course: chosenGroup,
      medium: "cerahKids",
      ...groupContactDetails,
    });
    updateState({
      groupContactDetails,
      classRequest: cr,
    });
    analytics.track("onlineJour.contactGiven", {groupContactDetails});
  }

  function testCallSchedulePickedGroup(testCallSchedule) {
    updateState({groupTestCallSchedule: testCallSchedule.toISOString()});
  }

  async function testCallConfirmedGroup() {
    let classRequestId, crToken;
    if (st.openClassRequestId && st.openClassRequestToken) {
      classRequestId = st.openClassRequestId;
      crToken = st.openClassRequestToken;
    } else {
      classRequestId = st.classRequest._id;
      crToken = st.classRequest.updateToken;
    }
    await classRequestApi.createTestCall({
      startTime: st.groupTestCallSchedule,
      classRequestId,
      guessedTimezone: moment.tz.guess()
    }, crToken);
    updateState({groupTestCallConfirmed: true});
    analytics.track("onlineJour.testCallConfirmed", {testCallSchedule: st.groupTestCallSchedule});
  }
}


function getActiveElements(st = {}) {
  let activeEls = [ageGroupEl];
  if (st.ageGroup && st.ageGroup[0] > 3) {
    activeEls.push(groupSizeEl)
  }
  if ((st.ageGroup && st.ageGroup[0] === 0) || st.chosenSize) {
    activeEls.push(choiceEl);
  }
  if (st.chosenSize === "privat") {
    activeEls = [...activeEls, ...getActiveElementsPrivate(st)];
  } else {
    activeEls = [...activeEls, ...getActiveElementsGroup(st)];
  }
  return activeEls;
}

function getActiveElementsPrivate(st = {}) {
  const activeEls = [];
  if (st.confirmed) {
    activeEls.push(scheduleEl);
  }
  if (st.pickedSchedule) {
    activeEls.push(scheduleSummaryEl);
  }
  if (st.scheduleConfirmed) {
    activeEls.push(teacherSelectionEl);
  }
  if (st.pickedTeacher) {
    activeEls.push(trialDateEl);
  }
  if (st.trialDate) {
    activeEls.push(emergencyContactMethodEl);
  }
  if (st.emergencyContactMethod) {
    activeEls.push(emergencyContactEl);
  }
  if (st.contactDetails) {
    activeEls.push(customerWhatsappConfirmationEl);
  }
  return activeEls;
}

const testTimes = Object.freeze({
  now: "now",
  later: "later"
});

function getActiveElementsGroup(st = {}) {
  const activeEls = [];
  if (st.confirmed) {
    activeEls.push(levelEl)
  }
  if (st.level === false) {
    if (st.ageGroup[0] >= 8)
      activeEls.push(chooseTestTimeEl);
    else
      activeEls.push(generalScheduleEl)
  }
  if (st.chosenTestTime === testTimes.later) {
    activeEls.push(deferredTestContactEl);
  } else if (st.chosenTestTime === testTimes.now) {
    activeEls.push(immediateTestContactEl);
  }
  if (st.level || st.testRequested) {
    activeEls.push(groupSelectionEl);
  }
  if (st.newGroupRequested) {
    activeEls.push(groupScheduleEl);
  }
  if (st.chosenGroup || st.groupScheduleRequested) {
    activeEls.push(groupTrialDateEl);
  }
  if (st.groupTrialDate || st.chosenSchedule) {
    activeEls.push(groupContactMethodEl);
  }
  if (st.groupContactMethod && !st.openClassRequestId) {
    activeEls.push(groupContactEl);
  }
  //should show schedule picker if
  // - the test has been done and the group level chosen is the same as the result of the test and
  // - contact details have been given and
  // - there are slots available and
  // - the student has chosen an existing group, not requested the creation of a new one
  const shouldShowSchedulePicker =
    st.testResultLevel && st.testResultLevel === st.level &&
    (st.groupContactDetails || (st.groupContactMethod && st.openClassRequestId)) &&
    Object.keys(st.groupAvailableSlots).length &&
    !st.groupScheduleRequested;
  if (shouldShowSchedulePicker) {
    activeEls.push(groupScheduleTestCallEl);
  }
  if (st.groupTestCallSchedule) {
    activeEls.push(groupConfirmTestCallEl);
  }
  //Either test call schedule has been picked or there are contact details but shouldn't show the schedule picker:
  if (st.groupTestCallConfirmed || ((st.groupContactDetails || (st.openClassRequestId && st.groupContactMethod)) && !shouldShowSchedulePicker)) {
    activeEls.push(groupCustomerWhatsappConfirmationEl);
  }
  return activeEls;
}

export const CerahKidsWizard = withWizard(CerahKidsWizardComponents, stateSteps, getActiveElements);
